/**
 * Whether the user wants clicks to open the inspector.
 *
 * Lives with the feature rather than with the Settings card that toggles it, so
 * a surface asking "should I offer this?" does not have to import from settings.
 *
 * Backed by `DisplayPrefsStore`, which the dashboard scopes to
 * `{ app: "dashboard" }` — remembered per browser, not per user. See
 * {@link InspectorSection} for why that is acceptable for now.
 */
import { useDisplayPref } from "@authe/ui-core";
import { displayPrefs } from "@/app/prefs";

export function useInspectorPref(): [boolean, (enabled: boolean) => void] {
  return useDisplayPref<boolean>(
    () => displayPrefs.getInspector(),
    (enabled) => displayPrefs.setInspector(enabled),
  );
}
